import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PanelStatuGuncelleModel, PanelstatuModel } from 'src/app/models/panelstatuModel';
import { TalepDetayModel } from 'src/app/models/talepdetayModel';
import { YorumAddModel } from 'src/app/models/yorumAddModel';
import { TalepService } from 'src/app/services/talep.service';

@Component({
  selector: 'app-talepdetay',
  templateUrl: './talepdetay.component.html',
  styleUrls: ['./talepdetay.component.css'],
})
export class TalepdetayComponent implements OnInit {
  constructor(
    private talepService: TalepService,
    private toastrService: ToastrService,
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute
  ) { }
  form: UntypedFormGroup;
  statusForm: UntypedFormGroup;
  loading = false;
  dataLoaded = false;
  submitted = false;


  panelStatuGuncelleModel: PanelStatuGuncelleModel;

  list: PanelstatuModel[] = [];
  yorum: YorumAddModel;
  talep: TalepDetayModel;
  servisid: number;
  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      aciklama: ['', Validators.required],
    });

    this.statusForm = this.formBuilder.group({
      status: ['', Validators.required],
      description: ['', Validators.required] 
    });

    this.GetPortalStatuList();



    this.activatedRoute.params.subscribe((params) => {
      this.servisid = params['kayitid'];
      this.TalepList(params['kayitid']);
    });
  }


  GetPortalStatuList() {
    this.talepService.GetPortalStatuList().subscribe((a) => {

      this.list = a.Veri;
    });


  }


  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }
    this.loading = true;

    this.yorum = Object.assign({}, this.form.value);
    this.yorum.servisid = this.servisid;


    this.talepService.YorumAdd(this.yorum).subscribe(
      (res) => {
        if (res.BasariliMi) {
          window.location.reload();
          this.toastrService.info('Mesaj Kaydedildi.', 'Başarılı!');

        } else {
          this.toastrService.error(res.Mesaj, 'Dikkat!1');

        }

        this.loading = false;
      },
      (err) => {
        this.toastrService.error(err.Mesaj, 'Dikkat!2');
        this.loading = false;
      }
    );
  }


  PortalStatuGuncelle() {
    this.submitted = true;

    if (this.statusForm.invalid) {
      return;
    }

    // Mevcut statü ile seçilen statü aynı mı kontrol et
    const mevcutStatu = this.talep.ServisDetayModel.ServisDurumu;
    const secilenStatuId = this.statusForm.get('status')?.value;
    const secilenStatu = this.list.find(x => x.Value == secilenStatuId)?.Text;

    if (mevcutStatu === secilenStatu) {
      this.toastrService.warning('Aynı statüyü tekrar seçemezsiniz!', 'Uyarı');
      return;
    }

    this.loading = true;

    this.panelStatuGuncelleModel = {
      aciklama: this.statusForm.get('description')?.value,
      servisid: this.servisid,
      statuid: secilenStatuId
    };
   


    this.talepService.PortalStatuGuncelle(this.panelStatuGuncelleModel).subscribe(
      (res) => {
        if (res.BasariliMi) {
     
          this.toastrService.info('Statü güncellendi.', 'Başarılı!');
          window.location.reload();
        } else {
          this.toastrService.error(res.Mesaj, 'Dikkat!');
        }
        this.loading = false;
      },
      (err) => {
        this.toastrService.error('Bir hata oluştu.', 'Dikkat!');
        this.loading = false;
      }
    );
  }

  TalepList(kayitid: number) {
    this.talepService.getTalepDetay(kayitid).subscribe((a) => {

      if (a.BasariliMi) {
        this.talep = a.Veri;
      } else {
        this.toastrService.info(a.Mesaj, 'Dikkat');
      }
      this.dataLoaded = true;
    });
  }

  onStatusChange() {
    if (this.statusForm.invalid) {
      return;
    }
    // Implement your status change logic here
    const selectedStatus = this.statusForm.value.status;
    // Example: Show a toast
    this.toastrService.info(`Durum değiştirildi: ${selectedStatus}`, 'Bilgi');
  }
}

